import {MySelectStyles} from "./MySelect.styles";
import {MySelectProps} from "./MySelect.props";

export const MySelect = ({...props}: MySelectProps) => {
  return (
    //@ts-ignore
    <MySelectStyles {...props}/>
  )
}